import { render } from "./SimpleSelector.vue?vue&type=template&id=c4c43e3c&scoped=true"
import script from "./SimpleSelector.vue?vue&type=script&lang=js"
export * from "./SimpleSelector.vue?vue&type=script&lang=js"

import "./SimpleSelector.vue?vue&type=style&index=0&id=c4c43e3c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c43e3c"]])

export default __exports__